import PropTypes from 'prop-types';
import React from 'react';
import { Loader, Icon } from 'components/HeroSemantic';

const ValidationStatus = ({ loading, success, failed }) => {
  if (loading) {
    return <Loader active inline size="small" style={{ display: 'inline-block' }} />;
  }

  if (success) {
    return <Icon name="checkmark" style={{ color: 'var(--owner-success)', width: '18px', height: '18px' }} />;
  }

  if (failed) {
    return <Icon name="close" style={{ color: 'var(--owner-danger)', width: '18px', height: '18px' }} />;
  }

  return null;
};

ValidationStatus.propTypes = {
  loading: PropTypes.bool,
  success: PropTypes.bool,
  failed: PropTypes.bool,
};

export default ValidationStatus;
